import {cs}  from "@Common/react/chain-services";
import {snv} from "@Common/utils/arr-path";

import {cleanItem, itemEditor, ui} from "../expo-types/expo-types";

import {SampleMailingCardLogic} from "./sample-mailing-card-logic";

export const sampleMailingCardModules = ({item}) => [
    {
        name: "sampleMailingCard",
        load: ({method}, next) => cs(
            ["logic", (_, next) => SampleMailingCardLogic({
                initSelected: item?.sampleShippingAddressId == null || item.sampleShippingAddressId !== 0,
                next,
            })],
            ({logic}) => next({
                ...method === "mailing" && {
                    ui: logic.ui,
                    itemEditor: {
                        ...logic.editor,

                        prepareSave: (item) => {
                            const {onSaved, selected, address} = logic.editor.prepareSave();
                            return ({
                                newValue: snv(
                                    item, ["sampleShippingAddressId"],
                                    !selected ? 0 : address?.idPrimary
                                ),
                                onSaved,
                            });
                        },
                    },
                    includeSampleCardCost: logic.includeSampleCardCost,
                },
                
                cleanItem: logic.cleanItem,
            }),
        ),
        expo: [cleanItem, itemEditor, ui("sampleMailingCard")],
        requires: ["method"],
    },
];
